<div class="printheader">
  <div class="card">
    <div class="card-header text-align-center padding-left-0px border-bot-1px">
      <div class="col-print-12 padding-left-0px">
        <div class="row margin-left-0px">
          <div class="col-print-1 padding-right-30px">
            <img src="garbhagudilogo(small).png" class="user-image-circle-65px img2 margin-top-15px">
          </div>
          
          <div class="col-print-7">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family13px">Corporate Office</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family">Kalyani Nagar Branch,</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-normal">#26,Patalamma Temple Street,</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-normal">Near Metro Station,</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-normal">Bengaluru.</label>
            </div>

          </div>
          <div class="col-print-4">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family13px">Contact Details</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-normal"><i class="fas fa-phone"></i> : 0877-224531</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-normal"><i class="fas fa-envelope"></i> : garbagudi&#64;healins.com</label>
            </div>

          </div>
          <!--<div class="col-md-6 padding-left-0px">

    <div class="row margin-left-0px">
      <div class="col-md-4 padding-right-0px">
        <label class="margin-bottom-0px f5 font-weight-normal float-right">Owner:</label>
      </div>
      <div class="col-md-5">
        <label class="margin-bottom-0px f5 font-weight-normal float-left">{{OwnerName}}</label>
      </div>
    </div>

    <div class="row margin-left-0px">
      <div class="col-md-4 padding-right-0px">
        <label class="margin-bottom-0px f5 font-weight-normal float-right">Gender/Age:</label>
      </div>
      <div class="col-md-5">
        <label class="margin-bottom-0px f5 font-weight-normal float-left">{{Gender}}/{{Age}}</label>
      </div>
    </div>

    <div class="row margin-left-0px">
      <div class="col-md-4 padding-right-0px">
        <label class="margin-bottom-0px f5 font-weight-normal float-right">Formatted Code:</label>
      </div>
      <div class="col-md-5">
        <label class="margin-bottom-0px f5 font-weight-normal float-left">{{FormattedCode}}</label>
      </div>
    </div>

    <div class="row margin-left-0px">
      <div class="col-md-4 padding-right-0px">
        <label class="margin-bottom-0px f5 font-weight-normal float-right">Protocol Start:</label>
      </div>
      <div class="col-md-5">
        <label class="margin-bottom-0px f5 font-weight-normal float-left">{{Protocolst | date:'dd-MMM-yyyy'}}</label>
      </div>
    </div>

    <div class="row margin-left-0px">
      <div class="col-md-4 padding-right-0px">
        <label class="margin-bottom-0px f5 font-weight-normal float-right">Infertility Type:</label>
      </div>
      <div class="col-md-5">
        <label class="margin-bottom-0px f5 font-weight-normal float-left">{{Infertility}}</label>
      </div>
    </div>
  </div>
  <div class="col-md-5">
    <div class="row margin-left-0px">
      <div class="col-md-4 padding-right-0px">
        <label class="margin-bottom-0px f5 font-weight-normal float-right">Cycle No:</label>
      </div>
      <div class="col-md-5">
        <label class="margin-bottom-0px f5 font-weight-normal float-left">{{CycleNo}}</label>
      </div>
    </div>

    <div class="row margin-left-0px">
      <div class="col-md-4 padding-right-0px">
        <label class="margin-bottom-0px f5 font-weight-normal float-right">Cycle Outcome:</label>
      </div>
      <div class="col-md-5">
        <label class="margin-bottom-0px f5 font-weight-normal float-left"></label>
      </div>
    </div>

    <div class="row margin-left-0px">
      <div class="col-md-4 padding-right-0px">
        <label class="margin-bottom-0px f5 font-weight-normal float-right">Base Location:</label>
      </div>
      <div class="col-md-5">
        <label class="margin-bottom-0px f5 font-weight-normal float-left"></label>
      </div>
    </div>
    <div class="row margin-left-0px">
      <div class="col-md-4 padding-right-0px">
        <label class="margin-bottom-0px f5 font-weight-normal float-right">Protocol:</label>
      </div>
      <div class="col-md-5">
        <label class="margin-bottom-0px f5 font-weight-normal float-left">{{Protocol}}</label>
      </div>
    </div>
    <div class="row margin-left-0px">
      <div class="col-md-4 padding-right-0px">
        <label class="margin-bottom-0px f5 font-weight-normal float-right">Protocol End:</label>
      </div>
      <div class="col-md-5">
        <label class="margin-bottom-0px f5 font-weight-normal float-left">{{ProtocolEd | date:'dd-MMM-yyyy'}}</label>
      </div>
    </div>
    <div class="row margin-left-0px">
      <div class="col-md-4 padding-right-0px">
        <label class="margin-bottom-0px f5 font-weight-normal float-right">Print Taken On:</label>
      </div>
      <div class="col-md-5">
        <label class="margin-bottom-0px f5 font-weight-normal float-left">{{Date | date:'dd-MMM-yyyy'}}</label>
      </div>
    </div>
  </div>-->
        </div>
      </div>
    </div>
    <div class="card-body padding-top-0px padding-bottom-0px">
      <!--<div class="col-md-12">
        <div class="row">
          <div class="col-md-5">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f2">B.Vikram Adithya</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f3 font-weight-normal">ID: GG-SHO-12223</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f3 font-weight-normal">Male, 45 Years</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f3 font-weight-normal">Bill date: 10-JUL-2019</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f3 font-weight-normal">Doctor: Dr.Rajagopal</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f3 font-weight-normal">Dr.Amaravathi</label>
            </div>
          </div>
        </div>
      </div>-->
    </div>

  </div>
</div>

